import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../config/usePrivateLink";

export default function DistributionKitLayout({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const tabs = [
    {
      id: "distributionKit",
      title: "Distribution Kit",
      icon: "ri-archive-stack-line",
      path: "/distribution/kits",
      activePaths: ["/distribution/kits"],
    },
    {
      id: "distributionReport",
      title: "Distribution Report",
      icon: "ri-file-chart-line",
      path: hasAccess("/distribution-kits/report")
        ? "/distribution-kits/report"
        : hasAccess("/distribution-kits/payment-receipt")
          ? "/distribution-kits/payment-receipt"
          : hasAccess("/distribution-kits/payment")
            ? "/distribution-kits/payment"
            : "/distribution-kits/report",
      activePaths: [
        "/distribution-kits/report",
        "/distribution-kits/payment-receipt",
        "/distribution-kits/payment",
      ],
    },
  ];

  return (
    <>
      <ModuleHeader tabs={tabs} />
      {children}
    </>
  );
}